import { Product, Location } from './types';
import { Leaf, Truck, Lock, BadgeCheck } from 'lucide-react';

export const CONTACT_INFO = {
  whatsapp: '61415209300',
  phone: '254721691983',
  whatsappDisplay: '+61 415 209 300',
  phoneDisplay: '+254 721 691 983',
  email: 'info@agelife.ke',
  website: 'agelife.ke'
};

export const PRODUCTS: Product[] = [
  {
    id: '1',
    name: 'ACT MOVE',
    purpose: 'Natural Pain Relief Capsules for Joint & Muscle Health',
    category: 'Pain & Mobility',
    description: 'Natural herbal capsules designed to support joint mobility, relieve muscle stiffness, and promote flexibility using traditional Jamu ingredients.',
    price: 1500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768216940/Actmove_Amplop_1_-_tinyjpg_ziwa5d.jpg',
    ingredients: 'Zingiberis Rhizoma (Ginger Root), Languatis Rhizoma (Galangal), Caryophylli Flos (Clove), Curcuma Xanthorrhiza (Temulawak).'
  },
  {
    id: '2',
    name: 'Aguever',
    purpose: 'Fever Relief & Body Weakness',
    category: 'Special Care',
    description: 'Natural capsules to help reduce fever and restore vitality during illness.',
    price: 2000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768217165/Mockup_Dus_Kapsul_u4i6mo.png',
    ingredients: 'Lumbricus Rubellus Extract (Red Earthworm), Curcuma Xanthorrhiza (Temulawak), Carica Papaya Leaf Extract.'
  },
  {
    id: '3',
    name: 'Alofec',
    purpose: 'Gut Cleanse Support',
    category: 'Digestive & Metabolic',
    description: 'Supports healthy digestion and relieves constipation through natural gut cleansing.',
    price: 2500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768217415/Desain_Mockup_Alofec_n25l3j.png',
    ingredients: 'Aloe Vera Extract, Psyllium Husk, Cassia Angustifolia (Senna Leaf), Honey.'
  },
  {
    id: '4',
    name: 'Arumpil',
    purpose: 'Female Vitality & Skin Radiance',
    category: 'Skin & Immunity',
    description: 'Boosts energy, supports women’s vitality, and promotes healthy, glowing skin with our traditional female vitality blend.',
    price: 2800,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768215892/Arumpil_100_Pil_1_-_tinyjpg_qyqiak.jpg',
    ingredients: 'Gallae (Majakani), Curcumae Domesticae Rhizoma (Turmeric), Parameriae Cortex (Kayu Rapet), Caudatum.'
  },
  {
    id: '5',
    name: 'Batunir',
    purpose: 'Kidney Stone Relief',
    category: 'Special Care',
    description: 'Herbal support for kidney health and stone relief.',
    price: 2500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768217606/Batunir_60_Kapsul_1_-_tinyjpg_o01zvy.jpg',
    ingredients: 'Strobilanthes Crispus (Keji Beling), Orthosiphon Aristatus (Cat\'s Whiskers), Sonchus Arvensis.'
  },
  {
    id: '6',
    name: 'Bawang Putih',
    purpose: 'Garlic Heart & Detox',
    category: 'Heart & Circulation',
    description: 'Garlic extract to support heart health, improve circulation, and aid detoxification.',
    price: 2200,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768217724/Bawang_Putih_60_Kapsul_2_-_tinyjpg_s1b9ab.jpg',
    ingredients: '100% Pure Allium Sativum Bulbus Extract (Garlic Bulb).'
  },
  {
    id: '7',
    name: 'BBERRY',
    purpose: 'Eye Antioxidant Support',
    category: 'Special Care',
    description: 'Rich in antioxidants to boost vision health and protect eyes from strain.',
    price: 2000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768217872/BBerry_Sachet_DUS_vcbvlu.png',
    ingredients: 'Vaccinium Myrtillus (Bilberry Extract), Daucus Carota (Carrot Extract), Vitamin A, Honey.'
  },
  {
    id: '8',
    name: 'Biloto',
    purpose: 'Immunity & Liver Detox',
    category: 'Liver & Detox',
    description: 'Supports liver detoxification and strengthens the immune system against infections.',
    price: 2500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768217987/Biloto_-_tinyjpg_zlih9c.jpg',
    ingredients: 'Curcuma Xanthorrhiza (Temulawak), Andrographis Paniculata (Sambiloto), Centella Asiatica (Gotu Kola).'
  },
  {
    id: '9',
    name: 'Diapil',
    purpose: 'Diabetes Support',
    category: 'Digestive & Metabolic',
    description: 'Helps maintain healthy blood sugar balance naturally.',
    price: 2800,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768218109/Diapil_12_Kapsul_2_-_tinyjpg_ogz4wv.jpg',
    ingredients: 'Momordica Charantia (Bitter Melon), Tinospora Crispa (Brotowali), Andrographis Paniculata.'
  },
  {
    id: '10',
    name: 'DS KOF',
    purpose: 'Respiratory Relief',
    category: 'Special Care',
    description: 'Provides relief for coughs and supports healthy breathing.',
    price: 1800,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768218456/DS_KOF_Mockup_oppwsu.png',
    ingredients: 'Glycyrrhiza Glabra (Licorice), Zingiber Officinale (Ginger), Mentha Piperita (Peppermint), Citrus Aurantifolia.'
  },
  {
    id: '11',
    name: 'Vita Sleep',
    purpose: 'Natural Sleep & Relaxation Support',
    category: 'Sleep & Calm',
    description: 'A calming herbal formula designed to promote deep, restful sleep and reduce anxiety for a refreshed morning.',
    price: 2500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768220610/VitaSleep_3D_xh57hu.png',
    ingredients: 'Valeriana Officinalis (Valerian Root), Myristica Fragrans (Nutmeg), Passiflora (Passion Flower).'
  },
  {
    id: '12',
    name: 'Narapet',
    purpose: 'Feminine Health & Tightening',
    category: 'Women\'s Wellness',
    description: 'Herbal formula specially designed to support feminine health, firmness, and overall well-being.',
    price: 3000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768221603/Mockup_3D_Kapsul_Narapet_trj757.jpg',
    ingredients: 'Parameria Laevigata (Kayu Rapet), Curcuma Domestica, Quercus Infectoria (Manjakani), Piper Betle (Betel Leaf).'
  },
  {
    id: '13',
    name: 'Shefertility',
    purpose: 'Natural Fertility Support',
    category: 'Women\'s Wellness',
    description: 'A blend of traditional herbs to support reproductive health, hormonal balance, and fertility.',
    price: 3500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768225607/Mockup_3D_Kapsul_Sheferti_mfa0go.jpg',
    ingredients: 'Boesenbergia Rotunda (Fingerroot), Curcuma Xanthorrhiza, Centella Asiatica, Ocimum Sanctum (Holy Basil).'
  },
  {
    id: '14',
    name: 'Menses',
    purpose: 'Menstrual Cycle Support',
    category: 'Women\'s Wellness',
    description: 'Helps regulate menstrual cycles and relieve discomfort associated with menstruation.',
    price: 2200,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768221668/Menses_18_Kapsul_1_-_tinyjpg_ohydxn.jpg',
    ingredients: 'Curcuma Domestica (Turmeric), Tamarindus Indica (Tamarind), Zingiber Officinale, Kaempferia Galanga.'
  },
  {
    id: '15',
    name: 'Slim DS',
    purpose: 'Natural Weight Management',
    category: 'Women\'s Wellness',
    description: 'Supports healthy metabolism and natural weight management goals.',
    price: 3000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768222675/Slim_DS_60_Kapsul_1_-_tinyjpg_ehzmbl.jpg',
    ingredients: 'Guazuma Ulmifolia (Jati Belanda), Camellia Sinensis (Green Tea), Murraya Paniculata (Orange Jasmine).'
  },
  {
    id: '16',
    name: 'Green Tea',
    purpose: 'Antioxidant & Metabolic Boost',
    category: 'Digestive & Metabolic',
    description: 'Concentrated green tea extract to boost metabolism and provide powerful antioxidant protection.',
    price: 1800,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768222758/Green_Tea_1_-_tinyjpg_ucy1rz.jpg',
    ingredients: '100% Camellia Sinensis Extract (Premium Green Tea).'
  },
  {
    id: '17',
    name: 'Negatal',
    purpose: 'Skin Health & Itch Relief',
    category: 'Skin & Immunity',
    description: 'Traditional remedy to soothe skin irritation, itching, and promote healthy skin.',
    price: 2200,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768222952/Negatal_18_Kapsul_1_-_tinyjpg_kqpowi.jpg',
    ingredients: 'Andrographis Paniculata, Curcuma Xanthorrhiza, Tinospora Crispa, Alstonia Scholaris.'
  },
  {
    id: '18',
    name: 'Jerawat',
    purpose: 'Herbal Acne Relief',
    category: 'Skin & Immunity',
    description: 'Formulated to help clear acne and maintain a clear, healthy complexion from within.',
    price: 2000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768223061/Jerawat_100_Pil_2_-_tinyjpg_gfetio.jpg',
    ingredients: 'Curcuma Xanthorrhiza, Centella Asiatica, Andrographis Paniculata, Caesalpinia Sappan.'
  },
  {
    id: '19',
    name: 'Top Up',
    purpose: 'Immune Defense & Vitality',
    category: 'Skin & Immunity',
    description: 'A powerful blend to top up your energy levels and strengthen the body\'s natural defenses.',
    price: 2000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768563309/Top-Up_mr1ilh.png',
    ingredients: 'Nigella Sativa (Black Cumin), Honey, Zingiber Officinale.'
  },
  {
    id: '20',
    name: 'Keladi Tikus',
    purpose: 'Cellular Health & Detox',
    category: 'Skin & Immunity',
    description: 'Traditionally used to support long-term cellular health and detoxification.',
    price: 2500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768563109/Keladi_tikus_45_Kapsul_2_-_tinyjpg_la0vqk.jpg',
    ingredients: 'Typhonium Flagelliforme Rhizoma Extract.'
  },
  {
    id: '21',
    name: 'Thyponisix',
    purpose: 'Advanced Immune Support',
    category: 'Skin & Immunity',
    description: 'Concentrated herbal formula for intensive immune system support.',
    price: 3000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768563667/Thyponisix_60_Kapsul_3_cagwpi.jpg',
    ingredients: 'Typhonium Flagelliforme, Andrographis Paniculata, Curcuma Zedoaria.'
  },
  {
    id: '22',
    name: 'Kelor DS',
    purpose: 'Superfood Nutrition',
    category: 'Digestive & Metabolic',
    description: 'Packed with essential vitamins and minerals from Moringa leaves to boost metabolism and immunity.',
    price: 1800,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768563459/Kelor_DS_18_Kapsul_1_-_tinyjpg_ekkv0a.jpg',
    ingredients: 'Moringa Oleifera Leaf Extract.'
  },
  {
    id: '23',
    name: 'VitaLiver',
    purpose: 'Liver Protection & Detox',
    category: 'Digestive & Metabolic',
    description: 'A specialized herbal blend to support liver function, protect against toxins, and promote regeneration of liver cells.',
    price: 2500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768565815/Vitaliver_90_caps_lkfkdb.png',
    ingredients: 'Curcuma Xanthorrhiza (Temulawak), Curcuma Domestica (Turmeric), Andrographis Paniculata.'
  },
  {
    id: '24',
    name: 'Uricid',
    purpose: 'Gout & Uric Acid Relief',
    category: 'Pain & Mobility',
    description: 'Herbal formula designed to help reduce uric acid levels and relieve joint pain and stiffness associated with gout.',
    price: 2000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768566922/Uricid_100_Pil_2_-_tinyjpg_yulsrd.jpg',
    ingredients: 'Sida Rhombifolia (Sidaguri), Sonchus Arvensis (Tempuyung), Curcuma Xanthorrhiza.'
  },
  {
    id: '25',
    name: 'Batugin Elixir',
    purpose: 'Kidney Stone & Urinary Support',
    category: 'Pain & Mobility',
    description: 'A herbal syrup elixir that supports kidney health and assists in the breakdown and expulsion of urinary stones.',
    price: 2800,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768567194/batugin_dulmhs.png',
    ingredients: 'Sonchus Arvensis Folia, Strobilanthes Crispus Folia.'
  },
  {
    id: '26',
    name: 'Kolespil',
    purpose: 'Cholesterol Balance',
    category: 'Heart & Circulation',
    description: 'Natural herbal support for maintaining healthy cholesterol levels and improving blood circulation.',
    price: 2400,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768570866/Kolespil_60_Kapsul_2_-_tinyjpg_wjyruf.jpg',
    ingredients: 'Gynura Procumbens, Guazuma Ulmifolia (Jati Belanda), Sonchus Arvensis.'
  },
  {
    id: '27',
    name: 'Maagfit',
    purpose: 'Gastric Comfort',
    category: 'Digestive & Metabolic',
    description: 'Soothes gastric discomfort, reduces acidity, and supports a healthy stomach lining.',
    price: 2000,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768570737/Maagfit_60_Kapsul_1_fy0jxs.jpg',
    ingredients: 'Curcuma Domestica (Turmeric), Nigella Sativa (Black Cumin), Curcuma Xanthorrhiza.'
  },
  {
    id: '28',
    name: 'Kunyit',
    purpose: 'Pure Turmeric Extract',
    category: 'Digestive & Metabolic',
    description: 'High-quality turmeric extract for digestive health, inflammation relief, and general vitality.',
    price: 1800,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768570627/Kunyit_2_e8zz1c.jpg',
    ingredients: '100% Curcuma Domestica Rhizoma Extract.'
  },
  {
    id: '29',
    name: 'Tensilon',
    purpose: 'Healthy Blood Pressure',
    category: 'Heart & Circulation',
    description: 'Formulated to help maintain normal blood pressure levels and support overall cardiovascular health.',
    price: 2500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768571567/Tensilon_100_Pil_Botol_1_p3lxkv.jpg',
    ingredients: 'Apium Graveolens (Celery), Orthosiphon Aristatus (Kumis Kucing), Centella Asiatica.'
  },
  {
    id: '30',
    name: 'Vibran',
    purpose: 'Heart Vitality & Circulation',
    category: 'Heart & Circulation',
    description: 'Supports heart muscle function and promotes healthy blood circulation throughout the body.',
    price: 2800,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1768571471/Mockup_3D_Kapsul_Vibran_wknyft.jpg',
    ingredients: 'Gynura Segetum, Curcuma Rhizoma, Centella Asiatica.'
  },
  {
    id: '31',
    name: 'Prostalon',
    purpose: 'Urinary Flow & Prostate Support',
    category: 'Special Care',
    description: 'Traditionally used to help ease urination and support prostate health.',
    price: 2500,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1769411785/Prostalon_60_Kapsul_3_-_tinyjpg_npe9ux.jpg',
    ingredients: 'Physalis Angulata, Centella Asiatica, Imperata Cylindrica, Orthosiphon Stamineus.'
  },
  {
    id: '32',
    name: 'Wasir',
    purpose: 'Hemorrhoid Symptom Relief',
    category: 'Special Care',
    description: 'Herbal remedy formulated to help relieve symptoms associated with hemorrhoids (piles) and reduce swelling.',
    price: 2200,
    image: 'https://res.cloudinary.com/djnukb8xv/image/upload/v1769411375/Wasir_18_Kapsul_1_c0tdux.jpg',
    ingredients: 'Graptophyllum Pictum (Daun Ungu), Curcuma Xanthorrhiza (Temulawak), Coleus Atropurpureus.'
  }
];

export const LOCATIONS: Location[] = [
  { city: 'Nairobi', country: 'Kenya' },
  { city: 'Mogadishu', country: 'Somalia' },
  { city: 'Kampala', country: 'Uganda' },
  { city: 'Addis Ababa', country: 'Ethiopia' },
  { city: 'Dar es Salaam', country: 'Tanzania' },
  { city: 'Kigali', country: 'Rwanda' },
];

export const FEATURES = [
  {
    title: 'Certified Organic',
    description: 'GMP, ISO & HALAL approved remedies.',
    icon: BadgeCheck,
  },
  {
    title: 'Jamu Tradition',
    description: '100% Natural Indonesian herbal heritage.',
    icon: Leaf,
  },
  {
    title: 'Fast Shipping',
    description: 'Reliable delivery across all East Africa.',
    icon: Truck,
  },
  {
    title: 'Secure Payments',
    description: 'Encrypted checkout for your safety.',
    icon: Lock,
  },
];